<template>
  <div>
    <p class="title text-left">六年风雨同行 共谱美好篇章</p>
    <p class="desc text-left">2019-3-12　<span class="author">及时雨小额贷款</span></p>
    <div class="main-content text-left">
      <p class="normal">2013年的3月8日，及时雨小额贷款股份有限公司正式经上海市政府批准成立。</p>
      <p class="normal">时光流逝，转眼到了2019年3月8日，及时雨小贷6岁了。</p>
      <p class="normal">过去6年来，及时雨小贷凭借专业的管理团队、先进的经营理念、丰富的行业经验、成熟的运作模式和创新的产品服务，专注于微型金融业务市场，努力为小企业，个体工商户提供专业、全面的小额信贷服务。</p>
      <div class="normal"><img src="../img/newsDetail/2-01.png" width="100%" alt=""></div>
      <p class="normal">平时大家更多的接触到及时雨团队专业的一面~
        <br>
        ~今天小编带你走进“及时雨小贷生日趴”！来了解一下及时雨人激情活波的一面！！</p>
      <p class="bold"><span>激情的及时雨小伙伴</span></p>
      <div class="normal"><img src="../img/newsDetail/2-02.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-03.png" width="100%" alt=""></div>
      <p class="bold"><span>周年庆创意比拼</span></p>
      <p class="normal">为庆祝6周年庆，各个部门的伙伴们用自己特有的方式，纷纷发挥自己的创意，为公司打Call，为前行加油！</p>
      <div class="normal"><img src="../img/newsDetail/2-04.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-05.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-06.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-07.png" width="100%" alt=""></div>
      <p class="bold"><span>美食生日趴 梦想再出发</span></p>
      <div class="normal"><img src="../img/newsDetail/2-08.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-09.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-10.png" width="100%" alt=""></div>
      <p class="bold"><span>6年风雨 感恩同行</span></p>
      <p class="normal">当天，及时雨人的朋友圈也开启了刷屏模式，一大波主题相同、造型各异的花式祝福照涌现出来，牢牢占住了大家的视线~</p>
      <div class="normal"><img src="../img/newsDetail/2-11.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-12.png" width="100%" alt=""></div>
      <div class="normal"><img src="../img/newsDetail/2-13.png" width="100%" alt=""></div>
      <p class="normal">在过去的6年里我们有微笑、有困难、也有收获，面对2019，我们将继续满怀憧憬，坚持“诚信 团队 创新 激情”，昂首阔步，书写更加灿烂的未来。</p>
      <p class="normal">未来，及时雨小贷将不忘初心，坚守金融核心——风控，利用科技让小微金融更简单；坚守梦想，更好的服务于小微企业！</p>
      <div class="normal"><img src="../img/newsDetail/2-14.png" width="100%" alt=""></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsDetail2"
  }
</script>

<style scoped lang="less">
  @import "newsDetail.less";
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail2.vue